/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PressKitOverallData } from './PressKitOverallData';
import {
    PressKitOverallDataFromJSON,
    PressKitOverallDataFromJSONTyped,
    PressKitOverallDataToJSON,
} from './PressKitOverallData';

/**
 * POST /press_kit
 * @export
 * @interface PostPressKitResponse
 */
export interface PostPressKitResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof PostPressKitResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof PostPressKitResponse
     */
    message: string;
    /**
     * 
     * @type {PressKitOverallData}
     * @memberof PostPressKitResponse
     */
    data: PressKitOverallData;
}

/**
 * Check if a given object implements the PostPressKitResponse interface.
 */
export function instanceOfPostPressKitResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function PostPressKitResponseFromJSON(json: any): PostPressKitResponse {
    return PostPressKitResponseFromJSONTyped(json, false);
}

export function PostPressKitResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressKitResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressKitOverallDataFromJSON(json['data']),
    };
}

export function PostPressKitResponseToJSON(value?: PostPressKitResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressKitOverallDataToJSON(value.data),
    };
}

